import { HStack, Text, Wrap, WrapItem, WrapProps } from "@chakra-ui/react";
import { ProductVariantInterface } from "../../constants/Product";
import { useBorderColor } from "../../themes/colors";
import formatNumber from "../../utils/helperFunction";

interface Props extends WrapProps {
  productId: string | undefined;
  data: ProductVariantInterface[] | undefined;
}

export const ListProductVariant = ({ productId, data, ...rest }: Props) => {
  const borderColor = useBorderColor();

  return (
    <Wrap spacing={2} {...rest}>
      {data &&
        data.map((item) => (
          <WrapItem
            key={item.id}
            py={1}
            px={2}
            borderWidth={"1px"}
            borderColor={borderColor}
            borderRadius={"md"}
            flexDirection={"column"}
          >
            <Text textStyle={"b-reg-sb"}>{item?.name}</Text>

            <HStack mt={2}>
              <Text textStyle={"b-sm"} variant={"secondary"}>
                Harga
              </Text>

              <Text textStyle={"b-sm"}>
                {item?.price && `: Rp ${formatNumber(item?.price)}`}
              </Text>
            </HStack>

            <HStack>
              <Text textStyle={"b-sm"} variant={"secondary"}>
                Stok
              </Text>

              <Text textStyle={"b-sm"}>
                {`: ${item.stock < 1 ? 0 : formatNumber(item?.stock)}`}
              </Text>
            </HStack>

            <HStack>
              <Text textStyle={"b-sm"} variant={"secondary"}>
                Persentase Komisi
              </Text>

              <Text textStyle={"b-sm"}>
                {`: ${
                  item.percentage && item.percentage !== 0
                    ? formatNumber(item?.percentage)
                    : "Default"
                }`}
              </Text>
            </HStack>
          </WrapItem>
        ))}
    </Wrap>
  );
};
